import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ShareQrcodePage } from './share-qrcode.page';
import { TranslateModule } from '@ngx-translate/core';
import { ShareModule } from '@ngx-share/core';

const routes: Routes = [
  {
    path: '',
    component: ShareQrcodePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild(),
    ShareModule
  ],
  declarations: [ShareQrcodePage]
})
export class ShareQrcodePageModule { }
